export const AnalyticsIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 12C22 8.26154 22 6.3923 21.1962 5C20.6695 4.08788 19.9121 3.33046 19 2.80385C17.6077 2 15.7385 2 12 2C8.26154 2 6.3923 2 5 2.80385C4.08788 3.33046 3.33046 4.08788 2.80385 5C2 6.3923 2 8.26154 2 12C2 15.7385 2 17.6077 2.80385 19C3.33046 19.9121 4.08788 20.6695 5 21.1962C6.3923 22 8.26154 22 12 22C15.7385 22 17.6077 22 19 21.1962C19.9121 20.6695 20.6695 19.9121 21.1962 19C22 17.6077 22 15.7385 22 12ZM16.5303 10.5303C16.8232 10.2374 16.8232 9.76256 16.5303 9.46967C16.2374 9.17678 15.7626 9.17678 15.4697 9.46967L13 11.9393L12.0303 10.9697C11.7374 10.6768 11.2626 10.6768 10.9697 10.9697L7.46967 14.4697C7.17678 14.7626 7.17678 15.2374 7.46967 15.5303C7.76256 15.8232 8.23744 15.8232 8.53033 15.5303L11.5 12.5607L12.4697 13.5303C12.7626 13.8232 13.2374 13.8232 13.5303 13.5303L16.5303 10.5303Z'
      fill='#5c6167'
    />
  </svg>
)
